import $ from 'jquery';
import 'select2';
import { isNil, isUndefined } from 'lodash';


$(function () {
  function setDefaults($element) {
    let defaultVals = $element.data('default-values');
    if (!isNil(defaultVals)) {
      $(defaultVals).each(function(_i, value) {
        let selectOption = new Option(value.text, value.id, true, true)
        $element.append(selectOption);
      });
    }
  }

  function intializeSelect2(element) {
    $(element).select2({
      allowClear: true,
      placeholder: 'Search',
      ajax: {
        url: () => element.dataset.optionsUrl,
        dataType: 'json',
        delay: 250
      },
      templateSelection: function (data, _container) {
        if (!isUndefined(data.data)) {
          Object.keys(data.data).forEach(key => $(data.element).attr(`data-${key}`, data.data[key]));
        }
        return data.text;
      },
      language: {
        noResults: function () {
          return element.dataset.noResultMessage || 'No results found';
        }
      }
    });
  }

  let components = $('select.remote_select_component');
  $(components).each(function(_index, element) {
    intializeSelect2(element);

    $(element).on('select2:select', function(_e) {
      window.dispatchEvent(new CustomEvent('select2:selected'));
    });

    $(element).on('select2:unselect', function (_e) {
      window.dispatchEvent(new CustomEvent('select2:unselected'));
    });

    /* Hacky Fix -- When the dropdown is open give the search input focus.
    * https://github.com/select2/select2/issues/5993#issuecomment-800927000
    *
    * The timeout was added because in a rare edge case where you have multiple
    * remote selects on the page and you click off one that is open, onto another
    * the first one you've clicked off will have it focus set. This is due to the
    * returns the first nature of querySelector. By forcing a timeout of 5 ms, this
    * gives enough time for the first select to close.
    */

    $(element).on('select2:open', function (event) {
      if (event.target !== element) return;

      setTimeout(() => {
        document.querySelector('.select2-dropdown input.select2-search__field').focus()
      }, 5);
    });

    $(element).on('select2:reinitialize!', function(_e) {
      $(this).val(null).trigger('change');
      intializeSelect2(this);
    });

    setDefaults($(element));

    $(element).on('change', function (_e) {
      let selectedOption = $(this).children('option:selected');
      $(JSON.parse($(this).attr('data-mappings'))).each(function (_i, mapping_name) {
        let value = $(selectedOption).attr(`data-${mapping_name}`);
        let elem = document.querySelector(`input[data-mapping-name="${mapping_name}"]`)
        elem.value = value;
        elem.dispatchEvent(new Event('change'));
      });
    });

    if (($(element).attr('multiple') === 'multiple') && $(element).attr('confirmRemoval') === 'confirm') {
      $(element).on('select2:unselecting', function (e) {
        let response = confirm('Are you sure, you want to remove the destination?'); // eslint-disable-line no-alert
        if (response !== true) {
          e.preventDefault();
          e.stopPropagation();
          $(element).on('select2:opening', function (openedElement) {
            openedElement.preventDefault();
            openedElement.stopPropagation();
            $(element).off('select2:opening');
          });
        } else {
          $(element).on('select2:open', function (_e) {
            $(element).off('select2:open');
            $(element).select2('close');
          });
        }
      });
    }
  });
});
